__turbopack_context__.v({
  "bannerContainer": "Banner-module__WzF86q__bannerContainer",
  "bannerContent": "Banner-module__WzF86q__bannerContent",
  "bannerIcon": "Banner-module__WzF86q__bannerIcon",
  "leftAligned": "Banner-module__WzF86q__leftAligned",
  "removePointer": "Banner-module__WzF86q__removePointer",
  "textContainer": "Banner-module__WzF86q__textContainer",
});
